import { gql } from '@apollo/client';

export const ADD_NEW_USER = gql`
  mutation addNewUser($input: AddNewUserInput!) {
    addNewUser(input: $input) {
      user {
        id
      }
    }
  }
`;

export interface AddNewUserQueryVariables {
  input: {
    email: string;
    name?: string | null;
    roleCodes: string[];
  };
}
